import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';
import { Button } from '@codex-brightworld/basics';
import { Icon } from '@codex-brightworld/icons';


const StyledIcon = styled(Icon)`
  width: 24px;
  height: 24px;
  margin: -3px 7px 0px 0px;
  
  > svg {
    > g {
      /* Hide border of the icon */
      path:nth-child(1) {
        display: none
      }
    }
  }
  
  svg path:last-child {
    fill: currentColor
  }
`;

const Loading = styled(Icon)`
  width: 24px;
  height: 24px;
  margin: -3px 7px 0px 0px;
  stroke: none;
  
  svg path:last-child {
    fill: currentColor
  }
`;

const ButtonAddToBasket = styled(Button)`
  width: 100%;
  padding-left: 0;
  padding-right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function AddToBasketButton(props) {

  const buttonIcon = props.download
    ? <StyledIcon icon={'download'} /> : <StyledIcon icon={'basket'} />;

  const buttons = props.showSpinner
    ? <Loading icon={'loading'} spin /> : buttonIcon;

  const buttonWithLabels = (
    <>
      {buttons}
      {' '}
      {props.buttonLabel}
    </>
  );

  return (
    <EnvironmentThemeProvider>
      <ButtonAddToBasket
        primary={props.full}
        positive={!props.download}
        disabled={props.disabled}
        onClick={props.onClick}
      >
        {props.children ? props.children : buttonWithLabels}
      </ButtonAddToBasket>
    </EnvironmentThemeProvider>
  );
}

AddToBasketButton.displayName = 'AddToBasketButton';

AddToBasketButton.propTypes = {
  full: PropTypes.bool,
  download: PropTypes.bool,
  buttonLabel: PropTypes.string,
  disabled: PropTypes.bool,
  showSpinner: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node
};

AddToBasketButton.defaultProps = {
  full: true,
  download: false,
  buttonLabel: 'No Label',
  disabled: false,
  showSpinner: false,
  onClick: () => {},
  children: undefined
};
